export const tierlevel = {
    title: 'Tier Benefits',
    sub_title: 'Collect crowns to remain your Whopper level',
    tabs_level:[
        {lv: 'Silver'},
        {lv: 'Gold'},
        {lv: 'Platinum'},
        {lv: 'Diamond'},
    ],
    level_name:[
        // {lv: 'Silver'},
        {lv: 'Gold'},
        {lv: 'Platinum'},
        {lv: 'Diamond'},
        {lv: ''},
    ],
    benefit_title: 'Benefits',
    condition_title: 'Conditions',
}
